import React from 'react';
import ProductCarousel from '../../product/ProductProfile/ProductCarousel';
import PointInfo from '../pointInfo/PointInfo';

function PointProfile() {
  return (
    <div className="w-full flex flex-wrap ">
      <div className="w-full  lg:w-1/2">
        <ProductCarousel images={[]} />
      </div>
      <div className="w-full lg:w-1/2">
        <PointInfo />
      </div>
    </div>
  );
}

export default PointProfile;
